// @ts-nocheck
import {
    IconButton
} from '@mui/material';
import {styled} from '@mui/material/styles';

export const CloseIconButton = styled(IconButton)(()  => ({
    position: 'absolute',
    right: '10px',
    top: '20px',
    color: 'gray'
}));